/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { ICacheKeysResponse, IErrorResponse } from "./data-contracts";
import { HttpClient, RequestParams } from "./http-client";

export class CacheApi<SecurityDataType = unknown> extends HttpClient<SecurityDataType> {
  /**
   * No description
   *
   * @tags Cache API
   * @name GetCacheKeys
   * @summary Get cache keys
   * @request GET:/api/cache
   * @response `200` `ICacheKeysResponse`
   * @response `401` `IErrorResponse` Not signed in.
   */
  getCacheKeys = (params: RequestParams = {}) =>
    this.request<ICacheKeysResponse, IErrorResponse>({
      path: `/api/cache`,
      method: "GET",
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Cache API
   * @name ClearCache
   * @summary Delete all cache entries
   * @request DELETE:/api/cache
   * @response `200` `void` Cache entries deleted.
   * @response `401` `IErrorResponse` Not signed in.
   */
  clearCache = (params: RequestParams = {}) =>
    this.request<void, IErrorResponse>({
      path: `/api/cache`,
      method: "DELETE",
      ...params,
    });
}
